import React from 'react';

import {
  useConfigContext,
  useUiResourceContext,
  useResultContext,
} from 'common/components/CopyMagic/contexts';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

const TriggerElement = () => {
  const { trigger, onOpen } = useConfigContext();
  const {
    open,
    setOpen,
    resetPromptValues,
    resetError,
    setLoading,
    setFeedbackSentiment,
    setGenerateAgain,
  } = useUiResourceContext();
  const { resetResult } = useResultContext();
  const trackOnOpen = useGeneratorTrackingCallback('useTrackOnOpen');
  const isDisabled = !!open; // button is disabled when the modal is open

  const handleClick = () => {
    resetError();
    resetResult();
    resetPromptValues();
    setLoading(false);
    setGenerateAgain(false);
    setFeedbackSentiment({ positive: null });
    setOpen(true);
    trackOnOpen();
    onOpen();
  };

  return React.cloneElement(trigger, { onClick: handleClick, disabled: isDisabled });
};

export default TriggerElement;
